module.exports = __webpack_public_path__ + "static/media/one.5fa16d15.svg";